import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from "../../core/auth/auth.service";
import {catchError} from "rxjs/operators";
import {Observable} from "rxjs/Observable";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    console.log('AuthGuard:canActivate:route', route);
    console.log('AuthGuard:canActivate:state', state);
    return this.authService.isSessionValid().do((isValid) => {
      if (!isValid) {
        this.router.navigate(['/login']);
      }
    }).catch((error) => {
      this.router.navigate(['/login']);
      return Observable.throw(error);
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/common/auth-guard.ts